<script>

  export default {
    props: {
      options: {
        type: null,
        default: () => [
          { value: 'all', text: 'Any', selected: false },
          { value: 'DEFAULT', text: 'Default', selected: false },
          { value: 'SUPPLIER', text: 'Supplier', selected: false },
          { value: 'CUSTOMER', text: 'Customer', selected: false },
        ]
      },
      filterKey: {
        type: String,
        default: 'type'
      },
      isExpanded: {
        type: Boolean,
        default: false
      },
      defaultFilters: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        organisationTypeFilter: this.defaultFilters,
        pivoting: false,
        boundCollapse: false,
        unWatcher: null,
      }
    },
    computed:{
      filters(){
        return this.options.map(el => {
          if (el.selected){
            return el.value
          }
        }).filter(el => el)
      }
    },
    created(){
      this.boundCollapse = Boolean(this.isExpanded)
      this.unWatcher = this.createFilterWatcher()
    },
    methods:{
      createFilterWatcher (){
        return this.$watch('filters', function (newVal, oldVal) {

          let filterValue = newVal

          if (newVal && newVal.length > 1 && newVal.indexOf('all') !== -1){
            // disable watcher
            this.unWatcher();
            // currently have 'all' and something else so unselect 'all'
            if (oldVal.indexOf('all') !== -1){
              // remove as small scope added
              // newVal.splice(newVal.indexOf('all'), 1)
              const element = this.options.find(el => el.value === 'all')
              if (element){
                element.selected = false
              }
              filterValue = this.filters;
            }else{
              // newVal = ['all']
              // remove all as 'all' scope added
              this.options.forEach(el => {
                if (el.value !== 'all' && el.selected){
                  el.selected = false
                }
              });
              filterValue = '';
            }
            // re-enable watcher
            this.unWatcher = this.createFilterWatcher();
          }else if(newVal && newVal.indexOf('all') !== -1){
            // catch from empty to 'all'
            filterValue = '';
          }

          const payload = {}
          payload[this.filterKey] = filterValue
          this.$emit('filter', payload)
        })
      },
    }
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-returnType
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter Organisation Type</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
        />
      </h3>
    </div>
    <FabricCollapse
      id="accordion-returnType"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      class="table-filters">
      <div class="block-content">
        <section
          v-for="(option, index) in options"
          :key="`op-${index}`"
          :class="{ 'hr-solid-line': option.value === 'all' }">
          <FabricCheckbox
            v-model="option.selected"
            slot-classes="tw-pl-3 tw-text-black"
          >{{ option.text }}</FabricCheckbox>
        </section>
      </div>
    </FabricCollapse>
  </div>
</template>
